import { ANCHOR_TAG_NAME, SPINNER_CLASSNAME } from './constants';
import { OWA_REFERENCE_ATTACHMENTS_ID } from './shouldProcessLink';
import LinkPlugin from '../plugin/LinkPlugin';
import { AttachmentWellViewState } from 'owa-attachment-well-data';
import { LINK_CONTEXT_MENU } from 'owa-compose-link';
import { trace } from 'owa-trace';
import { ChangeSource, ContentChangedEvent, PluginEvent } from 'roosterjs-editor-types';
import processAnchorElements, {
    AnchorElementsSource,
} from './processAnchorElementsFromHtmlContent';

// The content change source for upgrading compose
const UPGRADE_CHANGE_SOURCE = 'UpgradeCompose';
const ID_QUERY_PREFIX = '#';
const CLASS_QUERY_PREFIX = '.';
export default async function processContentChangedEvent(
    event: PluginEvent,
    linkPlugin: LinkPlugin,
    viewState: AttachmentWellViewState,
    linkIdsWithSpinner: string[]
) {
    const contentChangedEvent: ContentChangedEvent = event as ContentChangedEvent;
    if (
        contentChangedEvent.source === ChangeSource.SetContent || // load from draft, undo
        contentChangedEvent.source === UPGRADE_CHANGE_SOURCE || // the original content is added for reply or forward
        contentChangedEvent.source === LINK_CONTEXT_MENU // users undo beautification or edit hyper link from link context menu items
    ) {
        trace.info('LinkPlugin.processContentChangedEvent');
        const allLinks = linkPlugin.editor.queryElements(ANCHOR_TAG_NAME);
        const hiddenReferenceAttachments = linkPlugin.editor.queryElements(
            ID_QUERY_PREFIX + OWA_REFERENCE_ATTACHMENTS_ID
        );

        removeInvalidSpinner(linkPlugin, linkIdsWithSpinner);
        await processAnchorElements(
            allLinks,
            hiddenReferenceAttachments,
            AnchorElementsSource.ContentChangedFromSetContent,
            linkPlugin,
            viewState,
            linkIdsWithSpinner,
            contentChangedEvent.source === UPGRADE_CHANGE_SOURCE
        );
    }
}

function removeInvalidSpinner(linkPlugin: LinkPlugin, linkIdsWithSpinner: string[]) {
    linkPlugin.editor.queryElements(CLASS_QUERY_PREFIX + SPINNER_CLASSNAME, spinner => {
        if (linkIdsWithSpinner.indexOf(spinner.parentElement.id) === -1) {
            spinner.parentElement.removeChild(spinner);
        }
    });
}
